const Circle = (props?: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.2484 12.5008C19.2484 13.4529 19.0608 14.3957 18.6965 15.2753C18.3321 16.1549 17.7981 16.9541 17.1249 17.6273C16.4517 18.3006 15.6524 18.8346 14.7728 19.1989C13.8932 19.5633 12.9504 19.7508 11.9984 19.7508C11.0463 19.7508 10.1035 19.5633 9.2239 19.1989C8.34429 18.8346 7.54505 18.3006 6.87183 17.6273C6.1986 16.9541 5.66457 16.1549 5.30023 15.2753C4.93588 14.3957 4.74835 13.4529 4.74835 12.5008C4.74835 10.578 5.51219 8.73394 6.87183 7.3743C8.23147 6.01466 10.0755 5.25082 11.9984 5.25082C13.9212 5.25082 15.7652 6.01466 17.1249 7.3743C18.4845 8.73394 19.2484 10.578 19.2484 12.5008Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Circle;
